import i18n from 'i18next';
import { getTravellersMap } from '../../../utils';
import { getAeroexpressName } from './getAeroexpressName';
import { getRelatedServiceType } from './getRelatedServiceType';
import { includedOptionItemFactory } from './includedOptionItemFactory';
import { additionalOptionItemFactory } from './additionalOptionItemFactory';
import { optionGroupsFactory } from './optionGroupsFactory';
export function getAggregatedSummaryServices(additionalServices, segments, travellers, selectedServices, isConfirmed) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const gdsServices = (_b = (_a = additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services) !== null && _b !== void 0 ? _b : [];
    const travellersMap = getTravellersMap(travellers);
    const gdsServicesMap = new Map(gdsServices.map(service => [service.id, service]));
    const servicesProductsMap = new Map();
    const segmentsCount = segments.length;
    const summaryItemsByTypes = {
        Seat: [],
        Baggage: [],
        BaggageDelivery: [],
        Animal: [],
        Meal: [],
        BusinessLounge: [],
        PriorityBoarding: [],
        Insurance: [],
        Aeroexpress: [],
        Transfer: [],
        Loyalty: [],
        CapsuleHotel: [],
        Upgrade: [],
        Sms: []
    };
    // Insurance services
    if ((_d = (_c = additionalServices.insurances) === null || _c === void 0 ? void 0 : _c.selectedInsurances) === null || _d === void 0 ? void 0 : _d.length) {
        const availableInsuranceCodes = new Set((_g = (_f = (_e = additionalServices.insurances) === null || _e === void 0 ? void 0 : _e.insurancePrograms) === null || _f === void 0 ? void 0 : _f.map(insurance => insurance.code)) !== null && _g !== void 0 ? _g : []);
        const items = [];
        additionalServices.insurances.selectedInsurances.forEach(selectedInsurance => {
            const insuranceCode = selectedInsurance.insuranceProgram.code;
            if (availableInsuranceCodes.has(insuranceCode)) {
                const included = !!selectedInsurance.policyUrl || isConfirmed;
                items.push({
                    id: insuranceCode,
                    name: selectedInsurance.insuranceProgram.name,
                    price: selectedInsurance.insuranceProgram.totalPrice,
                    downloadUrl: included ? selectedInsurance.insuranceProgram.urlToOffer : null,
                    deleteMeta: !included ? { code: insuranceCode } : null,
                    included
                });
            }
        });
        if (items.length) {
            summaryItemsByTypes.Insurance.push({ items });
        }
    }
    // Transfer services
    if ((_k = (_j = (_h = additionalServices.transfer) === null || _h === void 0 ? void 0 : _h.aeroexpress) === null || _j === void 0 ? void 0 : _j.selectedTrips) === null || _k === void 0 ? void 0 : _k.length) {
        additionalServices.transfer.aeroexpress.selectedTrips.forEach(selectedTrip => {
            summaryItemsByTypes.Aeroexpress.push({
                header: i18n.t('All passengers', { ns: 'Checkout' }),
                items: [
                    {
                        id: selectedTrip.id,
                        name: getAeroexpressName(selectedTrip),
                        price: selectedTrip.price,
                        deleteMeta: { tripId: selectedTrip.id }
                    }
                ]
            });
        });
    }
    const optionsItemsMap = {};
    // Included services
    travellers.forEach(traveller => {
        var _a, _b, _c, _d, _e;
        const travellerId = traveller.id;
        if (!optionsItemsMap[travellerId]) {
            optionsItemsMap[travellerId] = {};
        }
        (_c = (_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.forEach(service => {
            var _a;
            const key = `${service.serviceId}/${service.segmentIds.join('/')}`;
            servicesProductsMap.set(key, [...((_a = servicesProductsMap.get(key)) !== null && _a !== void 0 ? _a : []), ...service.products]);
        });
        const includedServicesMap = new Map();
        (_e = (_d = traveller.services) === null || _d === void 0 ? void 0 : _d.brandIncludedServices) === null || _e === void 0 ? void 0 : _e.services.forEach(includedService => {
            var _a, _b, _c;
            const count = includedService.count;
            const key = `${(_b = (_a = includedService.service) === null || _a === void 0 ? void 0 : _a.rfisc) !== null && _b !== void 0 ? _b : includedService.serviceId}/${count}`;
            includedServicesMap.set(key, [...((_c = includedServicesMap.get(key)) !== null && _c !== void 0 ? _c : []), includedService]);
        });
        includedServicesMap.forEach(includedServices => {
            const segmentIds = new Set();
            includedServices.forEach(service => {
                service.segmentIds.forEach(segmentId => segmentIds.add(segmentId));
            });
            const isAllSegments = segmentIds.size === segmentsCount;
            const key = isAllSegments ? 'allSegments' : [...segmentIds][0];
            const actualService = includedServices[0];
            const type = actualService.service.type;
            const gdsServiceType = getRelatedServiceType(type);
            const productsKey = `${actualService.serviceId}/${actualService.segmentIds.join('/')}`;
            const products = servicesProductsMap.get(productsKey);
            const includedItem = includedOptionItemFactory({
                key,
                travellerId,
                segments,
                products,
                includedService: actualService
            });
            if (includedItem) {
                if (!optionsItemsMap[travellerId][key]) {
                    optionsItemsMap[travellerId][key] = {};
                }
                if (!optionsItemsMap[travellerId][key][gdsServiceType]) {
                    optionsItemsMap[travellerId][key][gdsServiceType] = [];
                }
                optionsItemsMap[travellerId][key][gdsServiceType].push(includedItem);
            }
        });
    });
    // Selected services
    const selectedServicesMap = new Map();
    for (const travellerId in selectedServices) {
        if (!optionsItemsMap[travellerId]) {
            optionsItemsMap[travellerId] = {};
        }
        for (const serviceId in selectedServices[travellerId]) {
            const services = selectedServices[travellerId][serviceId];
            if (!services) {
                continue;
            }
            const gdsService = gdsServicesMap.get(serviceId);
            services.forEach(service => {
                var _a, _b, _c;
                const count = 'confirmedCount' in service.servicePayload
                    ? (_a = service.servicePayload.confirmedCount) !== null && _a !== void 0 ? _a : service.number
                    : service.number;
                const key = `${(_b = gdsService === null || gdsService === void 0 ? void 0 : gdsService.rfisc) !== null && _b !== void 0 ? _b : serviceId}/${travellerId}/${count}`;
                selectedServicesMap.set(key, [
                    ...((_c = selectedServicesMap.get(key)) !== null && _c !== void 0 ? _c : []),
                    Object.assign(Object.assign({}, service), { travellerId, gdsService })
                ]);
            });
        }
    }
    selectedServicesMap.forEach(selectedServices => {
        var _a, _b, _c;
        const segmentIds = new Set();
        selectedServices.forEach(service => {
            service.segments.forEach(segmentId => segmentIds.add(segmentId));
        });
        const isAllSegments = segmentIds.size === segmentsCount;
        const key = isAllSegments ? 'allSegments' : [...segmentIds][0];
        const actualService = selectedServices[0];
        const serviceId = actualService.servicePayload.id;
        const travellerId = actualService.travellerId;
        const gdsService = actualService.gdsService;
        const type = (_b = (_a = actualService.servicePayload) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : gdsService === null || gdsService === void 0 ? void 0 : gdsService.type;
        const subType = (_c = gdsService === null || gdsService === void 0 ? void 0 : gdsService.baggageType) !== null && _c !== void 0 ? _c : gdsService === null || gdsService === void 0 ? void 0 : gdsService.subType;
        const gdsServiceType = getRelatedServiceType(type, subType);
        const productsKey = `${serviceId}/${actualService.segments.join('/')}`;
        const products = servicesProductsMap.get(productsKey);
        const additionalItem = additionalOptionItemFactory({
            key,
            travellerId,
            gdsServiceType,
            segments,
            products,
            service: actualService
        });
        if (!!additionalItem) {
            if (!optionsItemsMap[travellerId][key]) {
                optionsItemsMap[travellerId][key] = {};
            }
            if (!optionsItemsMap[travellerId][key][gdsServiceType]) {
                optionsItemsMap[travellerId][key][gdsServiceType] = [];
            }
            optionsItemsMap[travellerId][key][gdsServiceType].push(...(Array.isArray(additionalItem) ? additionalItem : [additionalItem]));
        }
    });
    const optionItemsByKey = new Map();
    for (const travellerId in optionsItemsMap) {
        for (const segmentKey in optionsItemsMap[travellerId]) {
            for (const type in optionsItemsMap[travellerId][segmentKey]) {
                const gdsServiceType = type;
                const items = optionsItemsMap[travellerId][segmentKey][gdsServiceType];
                if (!(items === null || items === void 0 ? void 0 : items.length)) {
                    continue;
                }
                const optionGroup = optionGroupsFactory({
                    items,
                    gdsServiceType,
                    segments,
                    key: segmentKey,
                    traveller: travellersMap.get(travellerId)
                });
                if (!Array.isArray(optionGroup)) {
                    // option items by traveller
                    if (gdsServiceType === 'Seat' || gdsServiceType === 'Meal') {
                        const travellerOptionItems = optionItemsByKey.get(travellerId);
                        if (travellerOptionItems) {
                            const gdsServiceOptionItems = travellerOptionItems.get(gdsServiceType);
                            if (gdsServiceOptionItems) {
                                gdsServiceOptionItems.items.push(...optionGroup.items);
                            }
                            else {
                                travellerOptionItems.set(gdsServiceType, optionGroup);
                            }
                        }
                        else {
                            optionItemsByKey.set(travellerId, new Map([[gdsServiceType, optionGroup]]));
                        }
                        continue;
                    }
                    // option items by sms key
                    else if (gdsServiceType === 'Sms') {
                        const key = `${optionGroup.items[0].id}/${gdsServiceType}`;
                        const smsOptionItems = optionItemsByKey.get(key);
                        if (smsOptionItems) {
                            const gdsServiceOptionItems = smsOptionItems.get(gdsServiceType);
                            if (gdsServiceOptionItems) {
                                gdsServiceOptionItems.items.push(...optionGroup.items);
                            }
                            else {
                                smsOptionItems.set(gdsServiceType, optionGroup);
                            }
                        }
                        else {
                            optionItemsByKey.set(key, new Map([[gdsServiceType, optionGroup]]));
                        }
                        continue;
                    }
                }
                summaryItemsByTypes[gdsServiceType].push(...(Array.isArray(optionGroup) ? optionGroup : [optionGroup]));
            }
        }
    }
    if (optionItemsByKey.size) {
        optionItemsByKey.forEach(optionItemsByGdsServiceType => {
            optionItemsByGdsServiceType.forEach((group, gdsServiceType) => {
                group.items.sort((a, b) => {
                    const aPriority = (a.included ? 1 : 0) + (a.segment === 'allSegments' ? 1 : 0);
                    const bPriority = (b.included ? 1 : 0) + (b.segment === 'allSegments' ? 1 : 0);
                    return bPriority - aPriority;
                });
                summaryItemsByTypes[gdsServiceType].push(group);
            });
        });
    }
    return summaryItemsByTypes;
}
